/**
 *
 * Asynchronously loads the component for EventGroup
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
